




import Vue from 'vue'
import Component from 'vue-class-component'
import ResidentPaymentHistory from '../components/ResidentPaymentHistory.vue'

@Component({
  components: { ResidentPaymentHistory }
})
export default class ResidentPaymentHistoryTab extends Vue {
  get residentId () {
    return this.$route.params.id
  }
}
